
import { useEffect, useState } from 'react';
import TextParticipation from '../UI/TextParticipation';

export function ManageConsent(
    interaction,
    participation,

) {
    const [consentGDPR, setConsentGDPR] = useState(false);
    const [consentImage, setConsentImage] = useState(false);
    const [consentGDPRText, setConsentGDPRText] = useState('');
    const [passerEtapeRGPDEnabled, setPasserEtapeRGPDEnabled] = useState(false);

    const setConsent = (event, type) => {
        if (type === "gdpr") {
            setConsentGDPR(event.target.checked);
            if (event.target.checked) {
                setConsentGDPRText(event.target.value);
                participation.consent_gdpr = event.target.value;
            }
            else {
                setConsentGDPRText('');
                participation.consent_gdpr = '';
            }
        }
        if (type === "image") {
            setConsentImage(event.target.checked);
        }
    }

    /** Initialiser 
     * 
     * @param {*} interaction 
     * @param {*} consentGDPR 
     * @param {*} consentImage 
     * @returns 
     */
    const CanGRPDContinue = () => {
        if (interaction.segment_customisation) {

            if (interaction.segment_customisation.consent_checkbox_image_right && interaction.segment_customisation.consent_checkbox) {
                setPasserEtapeRGPDEnabled(consentGDPR && consentImage);
                return
            }

            if (interaction.segment_customisation.consent_checkbox_image_right) {
                setPasserEtapeRGPDEnabled(consentImage);
                return;
            }

            if (interaction.segment_customisation.consent_checkbox) {
                setPasserEtapeRGPDEnabled(consentGDPR);
                return;
            }

            //Pas de checkbox à cocher
            setPasserEtapeRGPDEnabled(true);
            return;
        }

    }

    useEffect(() => {
        CanGRPDContinue();
    }, [consentGDPR, consentImage, interaction.segment_customisation])


    return {
        setConsent,
        setConsentGDPRText,
        setConsentGDPR,
        setConsentImage,
        consentGDPR,
        consentImage,
        consentGDPRText,
        passerEtapeRGPDEnabled,
    };
}

